var map = {
	"./ChrisZiporyn.jpg": 353,
	"./PeopleDiscussionHeader.jpg": 221,
	"./charlesczeisler.jpg": 354,
	"./joywake.png": 355,
	"./karioakes.jpg": 356,
	"./meafoster.jpg": 357,
	"./pallasziporyn.jpg": 358,
	"./phyllispayne.jpg": 359,
	"./postitheader.JPG": 360,
	"./stuartquan.jpg": 361,
	"./terraziporyn.jpg": 362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 352;